<template>
  <div id="overlay" v-if="showLoader">
    <div class="loader-box">
      <i class="icon icon-large-loader"></i>
      <p class="message">
        Please wait..
      </p>

    </div>
  </div>
</template>

<script>
export default {
  props: ['showLoader']
}
</script>



// WEBPACK FOOTER //
// src/components/loader.vue